<template>
  <div>
    <div class="bg-gray">
      <banner-bg
        title="查询"
        subtitle="Search"
        :src="require('@/assets/images/mainindex/pic-cha.png')"
      ></banner-bg>
      <special-tabs class="special-box" :activeName="activeName" :tabList="tabList" @onClick="onClick"></special-tabs>
 
      <!-- 各省市--> 
      <cha-person :activeName="activeName" v-show="activeName=='个人查询'" :areaOptions="areaOptions"  ></cha-person>
      <cha-danwei :activeName="activeName" v-show="activeName=='单位查询'" :areaOptions="areaOptions"  ></cha-danwei>
      <cha-caipan :activeName="activeName" v-show="activeName=='裁判员查询'" :areaOptions="areaOptions"  ></cha-caipan>
      <cha-jiaolian :activeName="activeName" v-show="activeName=='教练员查询'" :areaOptions="areaOptions"  ></cha-jiaolian>

    </div>
  </div>
</template>
<script>
import BannerBg from "@/components/mainindex/BannerBg";
import SpecialTabs from "@/components/mainindex/SpecialTabs";
import ChaPerson from "@/components/mainindex/ChaPerson";
import ChaDanwei from "@/components/mainindex/ChaDanwei";
import ChaCaipan from "@/components/mainindex/ChaCaipan";
import ChaJiaolian from "@/components/mainindex/ChaJiaolian";

export default {
  name: "ContactUs",
  components: {
    BannerBg,
    SpecialTabs,
    ChaPerson,
    ChaDanwei,
    ChaCaipan,
    ChaJiaolian,
  },
  data:function () {
    return {
      activeIndex:0,
      tabList: [
        { name: "个人查询", class: "tabs-item-active" }, 
        { name: "单位查询", class: "" },
        { name: "裁判员查询", class: "" },
        { name: "教练员查询", class: "" }, 
      ], 
      areaOptions:[],
      activeName: "个人查询"
    }
  },
  mounted() {
    document.title = "查询" 
    this.getAreaTreeFun();
  },
  methods: {
    onClick(record) {   
      this.activeName = record.name 
    },    
    getAreaTreeFun() {
      this.$api.get(
        "/api/utils/areaTree",
        {},
        (res) => {
          this.areaOptions = res.data;
          this.handleAreaOptionsLen();
        },
        (err) => {
          console.log(err);
        }
      );
    },
    handleAreaOptionsLen() {
      this.areaOptions.some((item1) => {
        item1.value = item1.title;
        if (item1.children) {
          item1.children.some((item2) => {
            item2.value = item2.title;
            if (item2.children) {
              delete item2.children;
            }
          });
        }
      });
    },

    handleAreaChange(value) {
      console.log('handleAreaChange',value);
      console.log('handleAreaChange',this.formLabelAlign.areas);
      this.formLabelAlign.area = this.formLabelAlign.areas[this.formLabelAlign.areas.length-1]
    },

    onSubmit(formName) {
      const that = this;
      console.log("formName");
      let url = ''
      if(this.activeName=='个人查询'&&this.activeIndex==0){
        url = '/api/cha/person'
      }else if(this.activeName=='个人查询'&&this.activeIndex==1){
        url = '/api/cha/personArea'
      }
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.$api.post(
            url,
            that.formLabelAlign,
            (res) => {  
              that.list = res.data;
            },
            (r) => {
              that.$message.error(r.msg);
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },  

    onYewuConfirm(value){
      console.log('onYewuConfirm',value)
      // return ;
        // this.formData.yewuName = value;
        let index  = this.yewuColumns.indexOf(value);
        this.formLabelAlign.yewuIndex = index+1;
        this.subColumns = this.subOptions[index].list;
        this.subLabel = this.subOptions[index].name;
        // if(this.subOptions[this.formData.yewuIndex-1].list.length>0){
        //     this.formData.subName =  this.subOptions[this.formData.yewuIndex-1].list[0].name;
        //     this.formData.subValue =  this.subOptions[this.formData.yewuIndex-1].list[0].value
        // }else{
        //     this.formData.subName =  '';
        //     this.formData.subValue = 0;
        // }
        // this.showYewuPicker = false;
    },
  }
};
</script>

<style scoped>
.container-content>>> img {
  max-width: 100%;
}
</style>
<style lang="scss" scoped>
.contact-box {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .contact-title {
    font-size: 18px;
    font-weight: 700;
  }

  .contact-desc {
    font-size: 16px;
  }

  .contact-img {
    width: 33.33%;
    text-align: center;
    margin-bottom: 20px;
  }
}

.container_wrap {
  width: 1200px;
  min-height: 803px;
  background: #ffffff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 20px 30px;
  margin: -27px auto 30px;

  img {
    width: 100%;
    border-radius: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// Cha.vue?45a9f8a2